import React from 'react'
import { Box, FlexGrid, Callout } from '@telus-uds/components-web'
import PiggyBank from '@telus-uds/palette-allium/build/web/icons/PiggyBank'
import { string } from 'prop-types'
import { StyledAppliedPromoCode } from './styles'

const AppliedPromoCode = ({ promoCode }) => {
  return (
    <FlexGrid.Row>
      <FlexGrid.Col>
        <Box top={1}>
          <StyledAppliedPromoCode>
            <Callout
              data-testid="appliedPromoCode"
              icon={PiggyBank}
              variant={{ rounded: true }}
              textAlignToFlex="left"
            >
              {promoCode}
            </Callout>
          </StyledAppliedPromoCode>
        </Box>
      </FlexGrid.Col>
    </FlexGrid.Row>
  )
}

AppliedPromoCode.propTypes = {
  promoCode: string.isRequired
}

export default AppliedPromoCode
